import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { AppearanceOptions, AppearanceSettings } from 'src/app/services/appearance-settings.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { CustomizerComponent } from 'src/app/layouts/full/shared/customizer/customizer.component';

@Component({
  selector: 'app-appearance-preferences',
  standalone: true,
  imports: [SharedModule, FileUploadComponent, CustomizerComponent],
  templateUrl: './appearance-preferences.component.html',
  styleUrl: './appearance-preferences.component.scss'
})
export class AppearancePreferencesComponent {
  file: File
  base64Image: string
  loading: boolean = false;

  // color skins
  skins = ['skin1', 'skin2', 'skin3', 'skin4', 'skin5', 'skin6'];

  updateAppearanceForm = new FormGroup({
    text: new FormControl('', [Validators.required]),
    logo: new FormControl('', [Validators.required]),
    colors: new FormGroup({
      logobg: new FormControl('', [Validators.required]),
      navbarbg: new FormControl('', [Validators.required]),
      sidebarbg: new FormControl('', [Validators.required])
    })
  });

  constructor(
    private userService: UserService,
    private appearanceSettingsService: AppearanceSettings,
  ) {

    this.getAppearanceData();

  }

  ngOnInit(): void {
    this.appearanceSettingsService.options$.subscribe((appearanceSettings) => {
      // update form
      const colorsGroup = this.updateAppearanceForm.get('colors') as FormGroup;
      colorsGroup.patchValue({ ...appearanceSettings })
    })
  }

  updateAppearanceSettings(newOptions: Partial<AppearanceOptions>) {
    // Change in the service
    this.appearanceSettingsService.updateOptions({
      ...newOptions
    })

    // update form
    const colorsGroup = this.updateAppearanceForm.get('colors') as FormGroup;
    colorsGroup.patchValue({ ...newOptions })

  }

  getAppearanceData() {
    if (this.userService.user.appearance) {
      this.updateAppearanceForm.patchValue({
        logo: this.userService.user.appearance.logo,
        text: this.userService.user.appearance.title,
        colors: this.userService.user.appearance.colors ? {
          logobg: this.userService.user.appearance.colors.logobg,
          navbarbg: this.userService.user.appearance.colors.navbarbg,
          sidebarbg: this.userService.user.appearance.colors.sidebarbg
        } : {}
      })
    }
  }

  onFileChange(file: File) {
    this.file = file;

    // Convert file to base64
    if (this.file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.toString();
        this.base64Image = base64.split(",")[1];
      }
      // reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsDataURL(this.file);
    }
  }

  handleReaderLoaded(e: any) {
    this.base64Image = e.target.result;
  }

  async saveChanges() {

    this.loading = true;


    // If there is a file selected, then upload and wait for the URL
    if (this.file) {

      let filename = `${this.userService.user.ID}_${this.file.name}`;

      // Upload the SVG file
      let response: any = await this.userService.uploadLogo(filename, this.base64Image);

      // If error uploading then stop and show error
      if (!response) {
        Swal.fire('错误！', '尝试上传标志时出错', 'error');
        this.loading = false;
        return;
      }

      this.updateAppearanceForm.patchValue({
        logo: response.fileUrl
      });

    }

    let request = {
      text: this.updateAppearanceForm.value.text,
      logo: this.updateAppearanceForm.value.logo,
      colors: {
        logobg: this.updateAppearanceForm.value.colors.logobg,
        navbarbg: this.updateAppearanceForm.value.colors.navbarbg,
        sidebarbg: this.updateAppearanceForm.value.colors.sidebarbg
      }
    };

    // Persist data for user text engraving
    this.userService.updateAppearance(request).subscribe((response) => {
      Swal.fire('已更新！', '外观已更新！', 'success');
      this.loading = false;
      // update user data
      this.userService.user.appearance = {
        logo: request.logo,
        title: request.text,
        colors: request.colors
      };

      window.location.reload();
    }, (err) => {
      Swal.fire('错误！', '尝试更新 3D 设计雕刻时出错', 'error')
      this.loading = false;
    });
  }
}
